<button
  *ngrxLet="isDisabled$ as disabled"
  mat-raised-button
  class="image !h-full"
  matTooltip="EzDent-i integration requires patient date of birth"
  [matTooltipDisabled]="!disabled"
  [disabled]="disabled"
  (click)="takeXRay()"
>
  Launch EzDent-i
</button>
